export const isOverFlowing = (element: Element) => {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth ||
    element?.children[0]?.scrollWidth > element?.children[0]?.clientWidth
  );
};
